/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcRouteV1FixOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_ROUTE_V1_FIX_ORDER_STATE_ENTITY_NAME = 'exc.route.v1.FixOrder';
export const excRouteV1FixOrderStateEntity = new schema.Entity<ExcRouteV1FixOrderState>(EXC_ROUTE_V1_FIX_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'clOrderId' });

